import VTable from "@/vuetify_custom/v-table/v3";
import { VBtn, VSelect, VIcon } from "vuetify/lib";
import { getsafe } from "@/libs/util.js";
import UploadImg from "@/views/fin/account_management/UploadImg.jsx";
import AbnormalModal from "@/views/fin/account_management/AbnormalModal.jsx";
import EditModalItem from "@/views/fin/account_management/EditModalItem.jsx";
import {
  postEpopMonthlyRecordUpdateApi,
  getEpopAccountDetailApi,
  download_attachment,
  epop_monthly_record_export_consume,
} from "@/views/fin/account_management/services.js";
import { ajaxUrl } from "@/libs/util.js";
import { VProgressLinear } from "vuetify/lib";
import { ACCOUNT_MANAGEMENT } from "@/views/fin/account_management/constants.js";
import upload_mixin from "@/views/fin/account_management/upload_mixin.js";
import styles from "@/views/fin/account_management/index.module.less";
import PictureView from "@/views/fin/account_management/PictureView.vue";
export default {
  mixins: [upload_mixin],
  props: {
    item: {
      type: Object,
    },
    showInput: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      detail: null,
      loading: false,
      verified_params: {
        id: null,
        verified: null,
      },
      need_upload_id: true,
    };
  },
  computed: {
    itsMyCustomerId() {
      const cur_id = getsafe(this, "$store.state.cur_customer.id", "");
      const customer_id = getsafe(this, "item.customer_id");
      return cur_id === customer_id;
    },
    month_table_fields() {
      const account_type = getsafe(this.item, "account_type", "");
      return [
        {
          text: "时间",
          align: "center",
          value: "year_month",
          width: 90,
        },
        {
          text: "月初余额",
          type: "money_field",
          value: "beginning_balance",
          width: 100,
        },
        {
          text: "当月充值",
          type: "money_field",
          value: "recharge_amount",
          width: 100,
        },
        {
          text: "当月消耗",
          type: "money_field",
          value: "consume_amount",
          width: 100,
        },
        {
          text: "投放记录金额",
          type: "money_field",
          value: "placing_amount",
          width: 100,
          show: account_type === "platform_recharge",
        },
        {
          text: "当月余额",
          type: "money_field",
          value: "current_balance",
          width: 100,
        },
        {
          // todo
          text: "异常变动",
          type: "money_field",
          value: "monthly_records",
          width: 100,
          render: (_, target) => {
            const verified = target.verified;
            return (
              <AbnormalModal
                canEdit={!verified}
                target={target}
                on={{
                  success: this.getData,
                }}
              />
            );
          },
        },
        {
          text: "说明",
          align: "center",
          value: "remark",
          width: 160,
          render: (val, t) => {
            return (
              <EditModalItem
                type="export_remark"
                title={getsafe(t, "remark")}
                target={t}
                on={{ success: this.getData }}
              />
            );
          },
        },
        {
          text: "余额截图",
          align: "center",
          value: "screenshots",
          width: 100,
          render: (_, target) => {
            const screenshots = getsafe(target, "screenshots", []);
            const verified = target.verified;
            return (
              <div style="block">
                <div>
                  {/* <EditAttachments 
                                files={screenshots}
                                modelType="EpopAccountMonthlyRecord"
                                modelId={target.id}
                                close={!verified}
                                on={{
                                    delSuccess: this.getData,
                                    clickFile: (file) => {
                                        
                                        this.$vModal.info({
                                            title: '图片',
                                            width: 800,
                                            okText: '关闭',
                                            render:() => {
                                                return <img
                                                 width={700}
                                                 src={`${ajaxUrl}/${download_attachment}?id=${file.id}`}/>
                                            }
                                        })
                                    }
                                }}
                            /> */}
                  {!!screenshots.length && (
                    <PictureView
                      pictureList={screenshots}
                      target={target}
                      url={`${ajaxUrl}/${download_attachment}`}
                      on={{
                        success: this.getData,
                      }}
                    />
                  )}
                  {!verified && (
                    <VIcon
                      x-small
                      style="cursor: pointer;"
                      on={{
                        click: () => {
                          this.$refs.img.edit(target);
                        },
                      }}
                    >
                      mdi-square-edit-outline
                    </VIcon>
                  )}
                </div>
              </div>
            );
          },
        },
        {
          text: "校验状态",
          align: "center",
          value: "verified",
          width: 100,
          render: (_, target) => {
            const verified = getsafe(target, "verified", null);
            return (
              <span>
                <VBtn
                  small
                  outlined
                  on={{
                    click: () => this.changeStatus(target),
                  }}
                  color={verified ? "success" : "warning"}
                >
                  {verified ? "已校验" : "未校验"}
                </VBtn>
              </span>
            );
          },
        },
        {
          text: "操作",
          b_text: "操作",
          align: "center",
          value: "action",
          width: 180,
          fixed: "right",
          type: "button_s_field",
          callBack: ({ key }, target) => {
            switch (key) {
              case "input":
                this.upload(target);
                break;
              case "output":
                this.output(target);
                break;
              case "generateBill":
                this.goExpenseGroupBill(target);
                break;
              default:
                break;
            }
          },
          buttons: (_, target) => {
            const verified = getsafe(target, "verified", null);
            return [
              {
                text: "导入数据",
                key: "input",
                show: !verified && (this.showInput || this.itsMyCustomerId),
              },
              {
                text: "导出数据",
                key: "output",
                show: true,
              },
              {
                text: "生成账单",
                key: "generateBill",
                show: true,
              },
            ].filter((i) => i.show);
          },
        },
      ].filter((i) => i.show === undefined || i.show);
    },
    monthly_consumptions_table_fields() {
      return [
        {
          text: "时间",
          align: "center",
          value: "year_month",
          width: 90,
        },
        {
          text: "投放SKU",
          align: "center",
          value: "sku_name",
          width: 200,
        },
        {
          text: "消耗金额",
          type: "money_field",
          value: "amount",
          width: 90,
        },
      ];
    },
    sku_consumptions_table_fields() {
      return [
        {
          text: "投放SKU",
          align: "center",
          value: "sku_name",
          width: 200,
        },
        {
          text: "消耗金额",
          type: "money_field",
          value: "amount",
          width: 90,
        },
      ];
    },
  },
  created() {
    this.getData();
  },
  methods: {
    output(target) {
      window.open(
        `/api/${epop_monthly_record_export_consume}?id=${target.id}`,
        "__blank"
      );
    },
    goExpenseGroupBill(target) {
      const contract = getsafe(this.item, "active_contract", {});
      const team_id = getsafe(this.item, "team.id");
      // const is_platform_recharge = getsafe(this.item, 'account_type') === 'platform_recharge'
      //   const team_id = getsafe(this.item, 'team.id')
      const unusual_changes = getsafe(target, "unusual_changes");
      let total = math.eval("0");
      unusual_changes.forEach((item) => {
        total = math.eval(`${total}+${getsafe(item, "change_amount", 0)}`);
      });
      total = math.eval(`${getsafe(target, "consume_amount", 0)}-${total}`);
      // if (is_platform_recharge) {
      //     this.$vModal.info({
      //         title: '提示',
      //         content: '平台充值的需要去投放记录中提账单'
      //     })
      //     return
      // }
      localStorage.setItem(
        ACCOUNT_MANAGEMENT,
        JSON.stringify({
          contract,
          team_id,
          total: total.toNumber(),
        })
      );
      window.open("/mine/expense_group_bill", "__blank");
    },
    changeStatus(data) {
      this.verified_params.id = data.id;
      this.verified_params.verified = data.verified;
      this.$vModal.confirm({
        title: "校验状态",
        render: () => {
          return (
            <VSelect
              v-model={this.verified_params.verified}
              label="账户状态"
              item-text="title"
              item-value="key"
              items={[
                {
                  title: "已校验",
                  key: true,
                },
                {
                  title: "未校验",
                  key: false,
                },
              ]}
            />
          );
        },
        loading: true,
        onOk: ({ destroy }) => {
          postEpopMonthlyRecordUpdateApi(this.verified_params)
            .then(this.getData)
            .finally(destroy);
        },
      });
    },
    getData() {
      this.loading = true;
      getEpopAccountDetailApi({ id: this.item.id })
        .then((res) => {
          this.detail = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  render() {
    return (
      <div style="padding:10px 20px">
        {this.loading && <VProgressLinear indeterminate />}
        <div style="max-width:1300px">
          <p class={styles["p-no"]}>月度消耗数</p>
          <VTable
            headers={this.month_table_fields}
            desserts={getsafe(this.detail, "monthly_records", [])}
          />
          <UploadImg
            ref="img"
            on={{
              success: this.getData,
            }}
          />
        </div>
        <div>
          <p class={styles["p-no"]}>分SKU的消耗</p>
          <div style="display:flex;max-width:1000px">
            <div style="margin-right:30px">
              <VTable
                headers={this.monthly_consumptions_table_fields}
                desserts={getsafe(this.detail, "monthly_consumptions", [])}
              />
            </div>
            <div>
              <VTable
                headers={this.sku_consumptions_table_fields}
                desserts={getsafe(this.detail, "sku_consumptions", [])}
              />
            </div>
          </div>
        </div>
        <div ref="contain" style="display:none" />
      </div>
    );
  },
};
